import { Artist as GQLItem } from '../../generated/graphql';
import * as ArtistLink from './ArtistLink';
import * as ArtistAttachment from './ArtistAttachment';
import { take } from '../../util';
import { z } from 'zod';

export const artistSchema = z.object({
  id: z.number().optional(),
  name: z.string(),
  bio: z.string().optional(),
  links: z.array(ArtistLink.artistLinkSchema).optional().default([]),
  attachments: z.array(ArtistAttachment.artistAttachmentSchema).optional().default([]),
  lastSynchronizedAt: z.string().optional(),
  synchronizationAvailable: z.boolean().optional(),
});

export type Artist = z.infer<typeof artistSchema>;

// Write shape accepted by `saveArtist` (maps to the GraphQL ArtistInput). It is
// structurally different from the read `Artist`: attachments are flat
// `{ attachmentId, _destroy? }`, not the nested `{ attachment: {...} }` returned
// by queries.
export type ArtistInput = {
  id?: number;
  name?: string;
  bio?: string;
  links?: ArtistLink.ArtistLink[];
  attachments?: ArtistAttachment.ArtistAttachmentInput[];
};

export const fromGql = (item: GQLItem): Artist => ({
  ...take<Artist>(item, 'id', 'name', 'bio', 'lastSynchronizedAt', 'synchronizationAvailable'),
  links: item.links ? ArtistLink.fromGqlCollection(item.links) : [],
  attachments: item.attachments ? ArtistAttachment.fromGqlCollection(item.attachments) : [],
});

export const fromGqlCollection = (items: GQLItem[]): Artist[] => (items || []).map(item => fromGql(item));
